(() => {
 const endpoint='/apps/stock-alerts';
 let challengeScript;
 function loadChallenge(){
  if(window.turnstile)return Promise.resolve();
  if(!challengeScript)challengeScript=new Promise((resolve,reject)=>{
   const s=document.createElement('script');s.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';s.async=true;s.onload=resolve;s.onerror=reject;document.head.append(s);
  });
  return challengeScript;
 }
 async function enhance(form){
  if(form.dataset.animixRestockChecked)return;
  form.dataset.animixRestockChecked='1';
  const variant=form.id.match(/^ContactFormNotifyStock(\d+)$/)?.[1];
  if(!variant)return;
  // Preserve the existing manual contact form until the service is enabled.
  let config;
  try{const r=await fetch(endpoint+'/config',{signal:AbortSignal.timeout(8000)});if(!r.ok)return;config=await r.json();if(!config.site_key)return;await loadChallenge();}catch{return;}
  if(!form.isConnected)return;
  const consent=document.createElement('label'),checkbox=document.createElement('input');
  checkbox.type='checkbox';checkbox.required=true;checkbox.style.marginRight='8px';
  consent.append(checkbox,document.createTextNode('Email me when this option is back in stock'));
  consent.style.cssText='display:block;font-size:13px;line-height:1.5;margin-bottom:14px';
  const challenge=document.createElement('div'),status=document.createElement('p');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
  const submit=form.querySelector('[type="submit"]');submit.before(consent,challenge,status);
  let token='',busy=false;
  const widget=window.turnstile.render(challenge,{sitekey:config.site_key,action:'restock',callback:value=>{token=value;},'expired-callback':()=>{token='';},'error-callback':()=>{token='';status.textContent='Verification could not load. Please try again';}});
  form.addEventListener('submit',async event=>{
   event.preventDefault();event.stopImmediatePropagation();
   if(busy)return;if(!form.reportValidity())return;
   if(!token){status.textContent='Please complete verification';return;}
   busy=true;submit.disabled=true;status.textContent='Saving your request…';
   try{
    const r=await fetch(endpoint+'/subscribe',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:form.querySelector('[name="contact[email]"]').value,variant_id:variant,consent:checkbox.checked,turnstile_token:token}),signal:AbortSignal.timeout(20000)});
    const data=await r.json();
    if(!r.ok||!data.ok)throw new Error(data.error==='already_available'?'This option is available now. Refresh the product page':'Unable to save your request. Please try again');
    status.textContent='You’re on the list. We’ll email you when this option is back in stock';
    submit.hidden=true;consent.hidden=true;window.turnstile.remove(widget);challenge.hidden=true;
   }catch(e){status.textContent=e.message==='This option is available now. Refresh the product page'?e.message:'Unable to save your request. Please try again';token='';window.turnstile.reset(widget);submit.disabled=false;}
   finally{busy=false;}
  },true);
 }
 const scan=()=>document.querySelectorAll('form[id^="ContactFormNotifyStock"]').forEach(enhance);
 new MutationObserver(scan).observe(document.documentElement,{subtree:true,childList:true});scan();
})();